<div class="filter-dialog">
    <div class="header">
        <h1>ФИЛЬТР</h1>
        <button mat-icon-button class="close-button" (click)="onNoClick()">
            <mat-icon>close</mat-icon>
        </button>

    </div>
    <div mat-dialog-content>
        <div class="content">
            <form class="form" [formGroup]="form">

                <pas-multi-select2 label="Архив"
                                   [options]="archiveStatuses"
                                   [formControlName]="'archive'">
                    <ng-template #optionTemplate let-option>
                        {{ option.name }}
                    </ng-template>
                    <ng-template #selectedTemplate let-selected>
                        {{ selected.name }}
                    </ng-template>
                </pas-multi-select2>

                <pas-multi-select3 [formControlName]="'organizations'"
                                   title="Учреждения"
                                   [customDataService]="organizationsService"
                                   customDialogMethod="apiOrganizationFilterlistGet"
                                   type="checkbox"
                                   [options]="{object:['Organization'], pageSize: 1e6}"
                >
                    <ng-template #listItem let-item>
                        {{ item.name }}
                    </ng-template>
                    <ng-template #dialogList let-item>
                        {{ item.name }} ({{ item.shortName }}) (ID:{{ item.id }})
                    </ng-template>
                </pas-multi-select3>
                <pas-multi-select3 [formControlName]="'organizationGroup'"
                                   title="Группа учреждений"
                                   [customDataService]="groupService"
                                   customDialogMethod="apiGroupFilterlistGet"
                                   type="checkbox"
                                   [options]="{object:['OrganizationGroup'], pageSize: 1e6}"
                >
                    <ng-template #listItem let-item>
                        {{ item.name }}
                    </ng-template>
                    <ng-template #dialogList let-item>
                        {{ item.name }} ({{ item.shortName }}) (ID:{{ item.id }})
                    </ng-template>
                </pas-multi-select3>
            </form>
            <h4 class="periods-header">Периоды</h4>
            <div class="periods">
                @for (period of periodService.getInitialStringArraySignal(); track period; let i = $index; ) {
                    <label class="period" [for]="'check'+i">
                        <mat-checkbox
                            (click)="periodService.selectPeriod(period)"
                            [checked]="periodService.selectedPeriodString().includes(period) || false"
                            [disabled]="!periodService.getStringArraySignal().includes(period)
                                || (periodService.getSelectedSignal()().length >= 4) && !periodService.isSelected(period)"
                        >{{ period }}
                        </mat-checkbox>
                    </label>
                } @empty {
                    Данных нет
                }
            </div>
        </div>


    </div>
    <div mat-dialog-actions>
        <button class="btn btn-blue" [style]="{color: 'white'}" mat-button (click)="onApply()" [disabled]="!form.valid || !periodService.getSelectedSignal()().length">
            Применить
        </button>
        <button class="btn btn-secondary" mat-button (click)="onReset()">Сбросить</button>
    </div>
</div>

